import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

import settings from '../services/app-settings';

const getDatadogConfig = (): RumInitConfiguration => ({
  applicationId: settings.datadog.appId,
  beforeSend: () => {
    const shouldSendEvent = settings.app.env !== 'local';
    return shouldSendEvent;
  },
  clientToken: settings.datadog.clientToken,
  env: settings.app.env,
  excludedActivityUrls: [(url) => url.startsWith('https://heapanalytics.com/h?')],
  premiumSampleRate: 100,
  sampleRate: 100,
  service: 'dashboard-ui',
  site: 'datadoghq.com',
  trackInteractions: true,
  version: 'latest', // This is a static value used to sync Datadog sourcemap uploads from MFEs.
});

export const initialiseDatadogRum = (): void => {
  try {
    datadogRum.init(getDatadogConfig());
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialise Datadog RUM:', error);
  }
};
